import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Tabs from "../../ui/Tabs";
import Modal from "react-modal";
import PayoutsTable from "../../components-bootstrap/PayoutsTable";
import { BodyBuilder } from "../../../exports/Images";
import moment from "moment";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import Discussions from "./Discussions";
import { createDiscussion } from "../../../redux/reducers/postApiSlice";
import { toast } from "react-toastify";
import { fetchAllRenewalTableData } from "../../../redux/reducers/apiSlice";
import UserDetails from "../user-details/UserDetails";
import BorderedButton from "../../payouts-wtf/common/BorderedButton";
import { selectAuth } from "../../auth/auth.selector";
import PaymentLinkForm from "../../payment-link-system/PaymentLinkForm";

const AllRenewalsTab = ({
  allRenewalTableData,
  searchString,
  setSearchString,
  onClickSearch,
}) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const initialDatas = {
    allDatas: [],
    regularDatas: [],
    goalFocusedDatas: [],
    ptDatas: [],
    addonDatas: [],
    nutritionDatas: [],
  };
  const [renewalData, setRenewalData] = useState(initialDatas);
  const initialDiscussionModal = {
    discussionModal: false,
    discussionData: [],
    discussionId: "",
  };
  const [discussionModalData, setDiscussionModalData] = useState(
    initialDiscussionModal
  );
  const initialUserDetails = {
    userDetailsModal: false,
    userInfo: [],
  };
  const [userDetails, setUserDetails] = useState(initialUserDetails);
  const TABS = [
    `All-${renewalData?.allDatas?.length || 0}`,
    `Regular-${renewalData?.regularDatas?.total || 0}`,
    `Goal focused-${renewalData?.goalFocusedDatas?.total || 0}`,
    `PT-${renewalData?.ptDatas?.total || 0}`,
    `Addon-${renewalData?.addonDatas?.total || 0}`,
    `Nutrition-${renewalData?.nutritionDatas?.total || 0}`,
  ];
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const [paymentLinkModal, setPaymentLinkModal] = useState(false);
  const [paymentLinkData, setPaymentLinkData] = useState({});
  const [imageModal, setImageModal] = useState(false);
  const [viewImage, setViewImage] = useState("");

  const onClickData = (e, data, name) => {
    e.preventDefault();

    if (name === "discussion-modal") {
      setDiscussionModalData({
        discussionModal: true,
        discussionData: data,
      });
    }

    if (name === "userdetails-modal") {
      setUserDetails({
        userDetailsModal: true,
        userInfo: data,
      });
    }
  };

  const onStartDiscussion = (e, data) => {
    e.preventDefault();

    const { user_id, gym_id, type, subscription_id } = data;

    const ctoHeadDetails = {
      user_id: user_id,
      gym_id: gym_id,
      discussion_status: "started",
      mem_type: type,
      staff_id: "JvXw3FgDE9OWm",
      subscription_id: subscription_id,
    };

    const payload = JSON.stringify(ctoHeadDetails);

    handleCreateDiscussion(payload, data, decryptedText?.token);
  };

  const handleCreateDiscussion = async (userData, data, authToken) => {
    try {
      const result = await dispatch(createDiscussion({ userData, authToken }));

      if (createDiscussion.fulfilled.match(result)) {
        setDiscussionModalData({
          discussionModal: true,
          discussionData: data,
          discussionId: result?.payload?.data?.[0]?.discussion_id,
        });
        dispatch(
          fetchAllRenewalTableData({
            queryParameters: "",
            token: decryptedText?.token,
          })
        );
      } else {
        const errorMessage = result.error.message;
        toast.error(errorMessage);
      }
    } catch (error) {
      console.log("handleCreateDiscussion ERROR => ", error);
    }
  };

  const allRewardsTableColumns = [
    {
      dataField: "name",
      text: "Member Name",
      formatter: (cell, row, rowIndex) => (
        <div className="emeberDetailsRowContainer">
          <img
            src={row?.profile || BodyBuilder}
            alt={row?.name || "N/A"}
            className="image"
            onClick={() => {
              setViewImage(row?.profile || BodyBuilder);
              setImageModal(true);
            }}
          />
          <p className="name">{row?.name || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "mobile",
      text: "Member Number",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">{row?.mobile || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "email",
      text: "Member Email",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name" style={{ textTransform: "lowercase" }}>
            {row?.email || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "gym_name",
      text: "Gym Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name" style={{ width: "150px" }}>
            {row?.gym_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "trainer_name",
      text: "Trainer",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name" style={{ width: "150px" }}>
            {row?.trainer_name || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "age",
      text: "Age",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">{row?.age || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "gender",
      text: "Gender",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name">{row?.gender || "N/A"}</p>
        </div>
      ),
    },
    {
      dataField: "type",
      text: "Plan Type (Category)",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name plan"
            style={{
              width: "150px",
              background:
                row?.type === "pt"
                  ? "#E1C3FF"
                  : row?.type === "goal_focus"
                  ? "#FFE6A5"
                  : row?.type === "addon_pt"
                  ? "#7C93C3"
                  : "#9EB8D9",
            }}
          >
            {row?.type === "addon_pt"
              ? "addon"
              : row.type?.replace(/_/g, " ") || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name plan"
            style={{
              width: "150px",
              background:
                row?.plan_name === "pt"
                  ? "#E1C3FF"
                  : row?.plan_name === "goal_focus"
                  ? "#FFE6A5"
                  : "#E1C3FF",
            }}
          >
            {(row?.type === "addon_pt" || row?.type === "addon"
              ? row?.addon_name?.replace(/_/g, " ")
              : row?.type === "regular"
              ? row?.plan_name?.replace(/_/g, " ")
              : row?.type === "nutrition"
              ? row?.diet_package_name?.replace(/_/g, " ")
              : row?.plan_name?.replace(/_/g, " ")) || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "price",
      text: "Plan Price",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name plan"
            style={{
              background: "#C5DFF8",
              color: "#4E4FEB",
              padding: "10px 15px",
            }}
          >
            ₹{row?.price || 0}
          </p>
        </div>
      ),
    },
    {
      dataField: "expire_date",
      text: "Expiring",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p className="name date" style={{ width: "120px" }}>
            {row?.expire_date
              ? moment(row.expire_date).tz("Asia/Kolkata").format("DD-MM-YYYY")
              : "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "checked_in_status",
      text: "Member Checkin Status",
      formatter: (cell, row) => (
        <div className="emeberDetailsRowContainer column">
          <p
            className="name plan"
            style={{
              width: "150px",
              background: row?.checked_in_status ? "#E2EFD5" : "#F6EFEF",
              color: row?.checked_in_status ? "#328300" : "#B80909",
            }}
          >
            {row?.checked_in_status ? "Checked In" : "Not Checked In" || "N/A"}
          </p>
        </div>
      ),
    },
    {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          {!row?.discussion_id ? (
            <button
              className="btn action startDiscussionBtn"
              onClick={(e) => onStartDiscussion(e, row)}
              disabled={!row?.checked_in_status}
            >
              start discussion
            </button>
          ) : (
            <button
              className="btn action"
              onClick={(e) => onClickData(e, row, "discussion-modal")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="28"
                viewBox="0 0 35 28"
                fill="none"
              >
                <path
                  d="M14.4793 7.00001C14.2919 6.99944 14.1064 7.03592 13.9332 7.10735C13.76 7.17877 13.6027 7.28373 13.4702 7.41619C13.3378 7.54864 13.2328 7.70598 13.1614 7.87914C13.09 8.05231 13.0535 8.23789 13.0541 8.42521V9.02703H20.1424C21.3667 9.02703 22.3784 10.0385 22.3784 11.263V16.9264C22.3784 17.2255 22.3166 17.513 22.2073 17.7751L24 19.5676V15.9189H24.6018C24.7891 15.9195 24.9747 15.883 25.1479 15.8116C25.3211 15.7402 25.4784 15.6352 25.6108 15.5027C25.7433 15.3703 25.8483 15.213 25.9197 15.0398C25.9911 14.8666 26.0276 14.681 26.027 14.4937V8.42501C26.0276 8.23771 25.9911 8.05215 25.9196 7.879C25.8482 7.70586 25.7432 7.54855 25.6108 7.41611C25.4783 7.28368 25.321 7.17874 25.1478 7.10733C24.9747 7.03592 24.7891 6.99944 24.6018 7.00001H14.4793ZM10.4252 9.83784C10.2379 9.83728 10.0523 9.87376 9.87914 9.94519C9.70598 10.0166 9.54864 10.1216 9.41619 10.254C9.28373 10.3865 9.17877 10.5438 9.10735 10.717C9.03592 10.8901 8.99944 11.0757 9.00001 11.263V16.9264C8.99947 17.1137 9.03597 17.2992 9.10741 17.4724C9.17884 17.6455 9.28381 17.8028 9.41626 17.9352C9.54871 18.0677 9.70604 18.1726 9.87919 18.244C10.0523 18.3154 10.2379 18.3519 10.4252 18.3514H11.027V22L14.6757 18.3514H20.1424C20.3297 18.3519 20.5153 18.3154 20.6884 18.244C20.8616 18.1726 21.0189 18.0676 21.1514 17.9352C21.2838 17.8027 21.3888 17.6454 21.4602 17.4722C21.5317 17.299 21.5681 17.1135 21.5676 16.9262V11.2628C21.5681 11.0755 21.5316 10.89 21.4602 10.7168C21.3887 10.5437 21.2838 10.3864 21.1513 10.254C21.0189 10.1215 20.8615 10.0166 20.6884 9.94517C20.5152 9.87375 20.3297 9.83728 20.1424 9.83784H10.425H10.4252Z"
                  fill="#BC0909"
                />
                <rect
                  x="0.426728"
                  y="1.30173"
                  width="34.1465"
                  height="25.3965"
                  rx="8.32327"
                  stroke="#CD0909"
                  strokeWidth="0.853456"
                />
              </svg>
            </button>
          )}
          <BorderedButton
            buttonText="Send link"
            // onClickButton={handleShowCheckboxes}
            onClickButton={() => {
              setPaymentLinkModal(true);
              setPaymentLinkData(row);
            }}
            // isDisabled={selectedInputList.selectedIndexes?.length === 0}
          />
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (allRenewalTableData) {
      setRenewalData({
        allDatas: allRenewalTableData?.data,
        regularDatas: allRenewalTableData?.memberShiptDetails?.regular,
        goalFocusedDatas: allRenewalTableData?.memberShiptDetails?.goal_focus,
        ptDatas: allRenewalTableData?.memberShiptDetails?.pt,
        addonDatas: allRenewalTableData?.memberShiptDetails?.addon,
        nutritionDatas: allRenewalTableData?.memberShiptDetails?.nutrition,
      });
    }
  }, [allRenewalTableData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <>
      <Modal
        isOpen={discussionModalData.discussionModal}
        onRequestClose={() =>
          setDiscussionModalData({
            ...discussionModalData,
            discussionModal: false,
          })
        }
        contentLabel="Discussion Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer discussionModalContainer">
          <ModalHeadAndClose
            title="Discussions"
            onClose={() =>
              setDiscussionModalData({
                ...discussionModalData,
                discussionModal: false,
              })
            }
          />
          <Discussions discussionModalData={discussionModalData} />
        </div>
      </Modal>

      <Modal
        isOpen={userDetails.userDetailsModal}
        onRequestClose={() =>
          setUserDetails({
            ...userDetails,
            userDetailsModal: false,
          })
        }
        contentLabel="User Details Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer userDetailsModalContainer">
          <ModalHeadAndClose
            title=""
            onClose={() =>
              setUserDetails({
                ...userDetails,
                userDetailsModal: false,
              })
            }
          />
          <UserDetails userDetails={userDetails} />
        </div>
      </Modal>

      <Modal
        isOpen={paymentLinkModal}
        onRequestClose={() => setPaymentLinkModal(false)}
        contentLabel="Payment Link Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer sendRenewalPaymentLinkModalContainer">
          <ModalHeadAndClose
            title="Payment Link"
            onClose={() => setPaymentLinkModal(false)}
          />

          <PaymentLinkForm
            paymentLinkData={paymentLinkData}
            closeModal={() => {
              setPaymentLinkModal(false);
              setPaymentLinkData({});
            }}
          />
        </div>
      </Modal>

      <Modal
        isOpen={imageModal}
        onRequestClose={() => setImageModal(false)}
        contentLabel="Discussion Brief Modal"
        ariaHideApp={false}
      >
        <div
          className="createNewCTOModalContainer discussionModalBriefContainer"
          style={{
            width: "auto",
            height: "auto",
          }}
        >
          <ModalHeadAndClose title=" " onClose={() => setImageModal(false)} />
          <div className="discussionModalMessage">
            <img
              src={viewImage}
              alt="profile"
              style={{
                width: "400px",
                height: "400px",
              }}
            />
          </div>
        </div>
      </Modal>

      {/* <ToastContainer /> */}

      <div className="tabsPayoutsContainer allPtMemTabs mb0">
        <div
          className="tabsSpacebetweenContainer"
          style={{ marginBottom: "20px" }}
        >
          <div className="tabsChild span4">
            <Tabs
              activeTab={activeTab}
              setActiveTab={setActiveTab}
              tabs={TABS}
              type="secondary"
            />
          </div>
          <div className="tabsChild span2 searchBarContainer">
            <input
              type="search"
              className="input-k px-3"
              placeholder="Search..."
              value={searchString}
              onChange={(e) => setSearchString(e.target.value)}
            />
            <button
              type="button"
              style={{
                background: "transparent",
                border: "none",
                cursor: "pointer",
              }}
              onClick={onClickSearch}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-search"
                viewBox="0 0 16 16"
              >
                <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
              </svg>
            </button>
          </div>
        </div>

        {activeTab === TABS[0] ? (
          <div className="allPtMembersTableContainer rewardsRenewal">
            <PayoutsTable
              columnsValues={allRewardsTableColumns}
              dataValues={renewalData?.allDatas}
            />
          </div>
        ) : activeTab === TABS[1] ? (
          <div className="allPtMembersTableContainer rewardsRenewal">
            <PayoutsTable
              columnsValues={allRewardsTableColumns}
              dataValues={renewalData?.regularDatas?.items}
            />
          </div>
        ) : activeTab === TABS[2] ? (
          <div className="allPtMembersTableContainer rewardsRenewal">
            <PayoutsTable
              columnsValues={allRewardsTableColumns}
              dataValues={renewalData?.goalFocusedDatas?.items}
            />
          </div>
        ) : activeTab === TABS[3] ? (
          <div className="allPtMembersTableContainer rewardsRenewal">
            <PayoutsTable
              columnsValues={allRewardsTableColumns}
              dataValues={renewalData?.ptDatas?.items}
            />
          </div>
        ) : activeTab === TABS[4] ? (
          <div className="allPtMembersTableContainer rewardsRenewal">
            <PayoutsTable
              columnsValues={allRewardsTableColumns}
              dataValues={renewalData?.addonDatas?.items}
            />
          </div>
        ) : activeTab === TABS[5] ? (
          <div className="allPtMembersTableContainer rewardsRenewal">
            <PayoutsTable
              columnsValues={allRewardsTableColumns}
              dataValues={renewalData?.nutritionDatas?.items}
            />
          </div>
        ) : (
          <div className="allPtMembersTableContainer rewardsRenewal">
            <PayoutsTable
              columnsValues={allRewardsTableColumns}
              dataValues={renewalData?.allDatas}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default AllRenewalsTab;
